import Breadcrumb from "../../../Components/Common/Breadcrumb";
import Tabs from "../../../Components/Common/Tabs";
import { simulatorTabsData } from "../../../data/SidebarData";
import StaticPageForm from "../../../Components/Common/Forms/StaticPageForm";

const SimlulatorMechaIndex = () => {
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={simulatorTabsData} />
      <StaticPageForm
        title="Mechanical Simulator"
        category={"mechanical"}
        promo
        subscription
      />
    </div>
  );
};

export default SimlulatorMechaIndex;
